import React from 'react';

import withStyles from '@mui/styles/withStyles';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';

import Modal from './Modal';
import CrmRadio from './CrmRadio';

const localStyles = (theme) => ({
  queryDiv: {
    fontSize: '20px',
  },
  radioButtonDiv: {
    marginLeft: '16px',
  },
});

/*
Call this with
    <InquiryConversionModal
        show={the condition under which it should show}
        convertFunc={a function to call to convert the inquiry into a prospect/emergencyContact/referralContact}
        closeFunc={a function for closing the dialog}
    />
*/

class InquiryConversionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: undefined,
      conversionType: 'prospect',
    };
  }

  shouldShowRefContactOption = false;

  handleConversionTypeChange = (event) => {
    this.setState({ conversionType: event.target.value });
  };

  render() {
    if (this.state.errorMessage) {
      return <h3>{this.state.errorMessage}</h3>;
    }

    const { classes, show, convertFunc, closeFunc } = this.props;
    return (
      <Modal
        open={show}
        title="Convert Lead"
        okButtonLabel="Convert"
        cancelButtonLabel="Cancel"
        onOk={() => convertFunc(this.state.conversionType)}
        onCancel={() => closeFunc()}
      >
        <div>
          <div className={classes.queryDiv}>Would you like to convert this person to a</div>

          <div className={classes.radioButtonDiv}>
            <FormControl variant="standard" component="fieldset" className={classes.formControl}>
              <RadioGroup
                aria-label="Contact Type"
                name="contact-type"
                value={this.state.conversionType}
                onChange={this.handleConversionTypeChange}
              >
                <FormControlLabel value="prospect" control={<CrmRadio />} label="Prospect" />
                <FormControlLabel value="emergencyContact" control={<CrmRadio />} label="Emergency Contact" />
                {this.shouldShowRefContactOption && (
                  <FormControlLabel value="referralContact" control={<CrmRadio />} label="Referral Company Contact" />
                )}
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      </Modal>
    );
  }
}

export default withStyles(localStyles)(InquiryConversionModal);
